import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import MenuItem from './MenuItem';
import { HugeiconsIcon } from '@hugeicons/react';
import { File02Icon, Archive02Icon } from '@hugeicons-pro/core-stroke-sharp';
import { File02Icon as File02IconSolid, Archive02Icon as Archive02IconSolid } from '@hugeicons-pro/core-solid-sharp';
import './ProjectMenu.css';
import { projectMeta, projectOrder } from '../projects/data';

// Simple Menu component
function ProjectMenu({
  onMenuItemClick,
  onHoverChange,
  hoveredId,
  hideOnZoom = false,
  hide = false,
  disableHover = false,
  returning = false,
  className = ''
}) {
  const timeoutRef = useRef(null);

  // Cleanup timeout on unmount
  React.useEffect(() => {
    const currentTimeout = timeoutRef.current;
    return () => {
      if (currentTimeout) {
        clearTimeout(currentTimeout);
      }
    };
  }, []);

  // Map data-defined icon keys to Hugeicons
  const iconMap = {
    user: { stroke: File02Icon, solid: File02IconSolid },
    archive: { stroke: Archive02Icon, solid: Archive02IconSolid }
  };

  // No fade; slide the entire menu vertically when overlay/zoom is active
  const menuItemsData = projectOrder.map((id) => {
    const meta = projectMeta[id] || {};
    const IconComp = meta.icon && iconMap[meta.icon]
      ? (props) => {
          const IconVariant = props.hovered ? iconMap[meta.icon].solid : iconMap[meta.icon].stroke;
          const { hovered, ...rest } = props;
          return <HugeiconsIcon icon={IconVariant} {...rest} />;
        }
      : undefined;
    const label = meta.shortTitle || meta.title || id;
    return { id, label, description: meta.description || '', icon: IconComp };
  });

  const specialItems = [];

  // Flat grid: no arc or rotation
  const menuItems = [...menuItemsData, ...specialItems];

  return (
    <motion.div
      className={`menu ${className}`.trim()}
      initial={false}
      animate={{ y: 0, opacity: 1 }}
      style={{ visibility: (hideOnZoom || hide) ? 'hidden' : 'visible' }}
      onMouseLeave={() => onHoverChange && onHoverChange('default')}
      transition={{ duration: 0 }}
    >
      <div className="menu-items" ref={(el) => {
        if (!el) return;
        // No special handlers
      }}>
        {menuItems.map((item, index) => (
          <MenuItem
            key={item.id}
            item={item}
            onClick={onMenuItemClick}
            onHoverChange={disableHover ? undefined : onHoverChange}
            isHovered={hoveredId === item.id}
            exitIndex={index}
            hideOnZoom={false}
            returning={returning}
          />
        ))}
      </div>
    </motion.div>
  );
}

export default ProjectMenu;